export default __webpack_public_path__ + "static/media/storageUnit1-afterA-1920w.be700223.avif";